import "antd/dist/reset.css";
import "./App.css";
import { AuthProvider } from "./useAuth";
import AppRoutes from "./AppRoutes";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, notification } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

notification.config({
  placement: "bottomRight",
  duration: 3,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
    },
  },
});

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#9D79BC",
                },
              }}
            >
              <AppRoutes />
            </ConfigProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}

export default App;
